import type { MigrationStrategies } from "./_types/migration-strategies";

export const EPOCUS_EXAM_MIGRATION_STRATEGIES: MigrationStrategies = {
  1: (oldDoc) => oldDoc,
  2: (oldDoc) => oldDoc,
  // Dropped rather than defaulted: a local copy cannot know its signature or
  // billing fields, and a guessed value would be pushed back over the real
  // one. The pull restarts once its checkpoint's document is gone.
  3: () => null,
};
